// (function($){
//     if($(window).width() < 600){
//         $($('qodef-woo-dropdown-cart-inner').html()).insertBefore('.qodef-mobile-header-opener');
//     }
// })(jQuery)